import syncModel from '../../../../services/models/Sync';
import InsumoPageState from '../models/InsumoPageState';

async function sync(state: InsumoPageState): Promise<void> {
  await syncModel.compraDeInsumos(state.filtroRapidoMostrarTodos);
  state.sync = true;
}

export default sync;
